/**
 * The `data-testid` values of the case images grid (Images of the Deceased)
 * and its Enhance flow, in the case details modal and the editor's Case tab.
 * The components draw them from here and their tests import them from here,
 * so a test can never look for an id the grid no longer draws.
 */
export const CASE_IMAGES_TEST_IDS = {
  GRID: 'case-images-grid',
  TILE: 'case-images-tile',
  TILE_IMAGE: 'case-images-tile-image',
  TILE_MENU_BUTTON: 'case-images-tile-menu-button',
  TILE_MENU: 'case-images-tile-menu',
  TILE_SET_DEFAULT: 'case-images-tile-set-default',
  TILE_ENHANCE: 'case-images-tile-enhance',
  TILE_COMPARE: 'case-images-tile-compare',
  TILE_REVERT: 'case-images-tile-revert',
  TILE_SHOW_ENHANCEMENT: 'case-images-tile-show-enhancement',
  TILE_DELETE: 'case-images-tile-delete',
  TILE_DEFAULT_CHECK: 'case-images-tile-default-check',
  TILE_AI_TAG: 'case-images-tile-ai-tag',
  LOW_RES_BADGE: 'case-images-low-res-badge',
  LOW_RES_TOOLTIP: 'case-images-low-res-tooltip',
  LOW_RES_ENHANCE: 'case-images-low-res-enhance',
  ENHANCE_MODAL: 'case-images-enhance-modal',
  ENHANCE_PANEL: 'case-images-enhance-panel',
  ENHANCE_DISCLOSURE: 'case-images-enhance-disclosure',
  ENHANCE_PRICE: 'case-images-enhance-price',
  ENHANCE_GENERATIVE_NOTICE: 'case-images-enhance-generative-notice',
  ENHANCE_DISCLOSURE_CONFIRM: 'case-images-enhance-disclosure-confirm',
  ENHANCE_DISCLOSURE_CANCEL: 'case-images-enhance-disclosure-cancel',
  ENHANCE_ENHANCING: 'case-images-enhance-enhancing',
  ENHANCE_PROGRESS: 'case-images-enhance-progress',
  ENHANCE_ENHANCING_CANCEL: 'case-images-enhance-enhancing-cancel',
  ENHANCE_COMPLETE: 'case-images-enhance-complete',
  ENHANCE_ACCEPT: 'case-images-enhance-accept',
  ENHANCE_COMPLETE_CANCEL: 'case-images-enhance-complete-cancel',
  ENHANCE_ERROR: 'case-images-enhance-error',
  ENHANCE_ERROR_MESSAGE: 'case-images-enhance-error-message',
  ENHANCE_TRY_AGAIN: 'case-images-enhance-try-again',
  ENHANCE_ERROR_CANCEL: 'case-images-enhance-error-cancel',
  ENHANCE_COMPARE: 'case-images-enhance-compare',
  ENHANCE_PREVIOUS: 'case-images-enhance-previous',
  ENHANCE_COMPARE_DONE: 'case-images-enhance-compare-done',
  ENHANCE_COMPARE_REVERT: 'case-images-enhance-compare-revert',
  ENHANCE_REVERT_CONFIRM: 'case-images-enhance-revert-confirm',
  ENHANCE_REVERT_ACCEPT: 'case-images-enhance-revert-accept',
  ENHANCE_REVERT_KEEP: 'case-images-enhance-revert-keep',
  ENHANCE_CHANGED: 'case-images-enhance-changed',
  ENHANCE_CHANGED_DONE: 'case-images-enhance-changed-done',
  COMPARE_SLIDER: 'case-images-compare-slider',
} as const
